import xhr from 'live/services/xhr'
import { RigStateChannels, StandardChannel, Channel, MappedChannel, SelectOptions } from '../../types'
import { saveRigFloorConfig } from '../../services/api'

type Entries = Record<string, MappedChannel & { unit: string }>

export function transformRigStateChannelsToConfig(rigStateChannels: RigStateChannels): Entries {
    const entries: Entries = {}

    rigStateChannels.channels?.forEach(
        (mappedChannel: Channel, keyChannel: StandardChannel) =>
            (entries[keyChannel.identifier] = {
                mnemonic: mappedChannel.mnemonic,
                unit: mappedChannel.unit,
                interpolationParameters: mappedChannel.interpolationParameters
            })
    )

    return entries
}

export const hasSelectedEquipment = (equipments: SelectOptions[]): boolean => {
    return equipments.some(it => it != null)
}

export function secondsToMilliseconds(seconds: number): number {
    if (seconds === 0) return seconds

    return seconds * 1000
}

export interface SaveRigFloorProcessConfigParams {
    assetType: string
    assetId: string
    operationType: string
    hydratongEquipmentUUID: string | undefined
    hydrarackerEquipmentUUID: string | undefined
    topDriveEquipmentUUID: string | undefined
    rrtEquipmentUUID?: string
    catwalkEquipmentUUID?: string
    rigFloorMethodology: string
    rigFloorUseInterpolation: boolean
    rigFloorInterpolationFrequency: number
    rigFloorMaxDeltaWithoutInterpolation: number
    riserUseInterpolation: boolean
    riserInterpolationFrequency: number
    riserMaxDeltaWithoutInterpolation: number
}

export const saveRigFloorProcessConfig = ({
    assetType,
    assetId,
    operationType,
    hydratongEquipmentUUID,
    hydrarackerEquipmentUUID,
    topDriveEquipmentUUID,
    rrtEquipmentUUID,
    catwalkEquipmentUUID,
    rigFloorMethodology,
    rigFloorUseInterpolation,
    rigFloorInterpolationFrequency,
    rigFloorMaxDeltaWithoutInterpolation,
    riserUseInterpolation,
    riserInterpolationFrequency,
    riserMaxDeltaWithoutInterpolation
}: SaveRigFloorProcessConfigParams): Promise<any> => {
    const data = {
        hydratongEquipmentUUID,
        hydrarackerEquipmentUUID,
        topDriveEquipmentUUID,
        rrtEquipmentUUID,
        catwalkEquipmentUUID,
        rigFloorMethodology,
        rigFloorUseInterpolation,
        rigFloorInterpolationFrequency,
        rigFloorMaxDeltaWithoutInterpolation,
        riserUseInterpolation,
        riserInterpolationFrequency,
        riserMaxDeltaWithoutInterpolation
    }

    return saveRigFloorConfig(assetType, assetId, operationType, data)
}

export function validatePipeExpression(expression: string): Response {
    return xhr.post('/rest/span', {
        expression: expression
    })
}

const CUSTOM_DATE_RANGE_PATTERN =
    /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(:\d{2})? to (\d{4}-\d{2}-\d{2} \d{2}:\d{2})(:\d{2})?$/

export function normalizeSpanExpression(span?: string): string {
    if (!span) return span ?? ''

    const match = span.match(CUSTOM_DATE_RANGE_PATTERN)
    if (!match) return span

    const [, startDateTime, startSeconds, endDateTime, endSeconds] = match

    return `${startDateTime}${startSeconds || ':00'} to ${endDateTime}${endSeconds || ':00'}`
}
